import React from 'react';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <section style={{ marginBottom: '2.5rem' }}>
    <h2 style={{
      fontSize: '1.2rem', fontWeight: '600', color: '#00F2FE',
      marginBottom: '1rem', paddingBottom: '0.5rem',
      borderBottom: '1px solid rgba(0, 242, 254, 0.15)',
    }}>
      {title}
    </h2>
    <div style={{ color: 'rgba(255,255,255,0.75)', lineHeight: '1.8', fontSize: '0.95rem' }}>
      {children}
    </div>
  </section>
);

const InfoBox = ({ children }) => (
  <div style={{
    background: 'rgba(0,242,254,0.04)', borderRadius: '10px',
    padding: '1rem 1.2rem', border: '1px solid rgba(0,242,254,0.08)',
    marginTop: '0.8rem', display: 'flex', flexDirection: 'column', gap: '0.35rem',
  }}>
    {children}
  </div>
);

const Row = ({ label, value }) => (
  <p style={{ margin: 0 }}>
    <strong style={{ color: 'rgba(255,255,255,0.9)' }}>{label} :</strong>{' '}
    <span>{value}</span>
  </p>
);

const MentionsLegalesPage = () => (
  <div style={{
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #050B1A 0%, #0A1628 50%, #0F1B3C 100%)',
    padding: '2rem 1rem 4rem',
  }}>
    <div style={{ maxWidth: '760px', margin: '0 auto' }}>

      {/* Header */}
      <div style={{ marginBottom: '3rem' }}>
        <Link to="/" style={{
          color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.9rem',
          display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
          marginBottom: '2rem', transition: 'color 0.2s',
        }}
          onMouseEnter={(e) => e.target.style.color = '#00F2FE'}
          onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
        >
          ← Retour à l'accueil
        </Link>
        <h1 style={{
          fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', fontWeight: '700',
          color: 'white', marginBottom: '0.5rem', letterSpacing: '-0.02em',
        }}>
          Mentions légales
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.9rem' }}>
          SafeHeir — En vigueur depuis Mai 2026
        </p>
      </div>

      <div style={{
        background: 'rgba(10, 22, 40, 0.6)', backdropFilter: 'blur(20px)',
        borderRadius: '20px', padding: '2.5rem',
        border: '1px solid rgba(0, 242, 254, 0.1)',
      }}>

        <Section title="1. Éditeur du site">
          <p>
            Le site SafeHeir est édité par :
          </p>
          <InfoBox>
            <Row label="Nom / Raison sociale" value="Azzedi Salemkour" />
            <Row label="Statut juridique" value="Projet en cours de structuration juridique" />
            <Row label="SIREN" value="En cours d'immatriculation" />
            <Row label="Adresse" value="Gennevilliers, 92230, France" />
            <Row label="Capital social" value="N/A" />
            <Row
              label="Contact"
              value={
                <a href="mailto:contact@safeheir.fr" style={{ color: '#00F2FE', textDecoration: 'none' }}>
                  contact@safeheir.fr
                </a>
              }
            />
          </InfoBox>
        </Section>

        <Section title="2. Directeur de la publication">
          <p>
            Le directeur de la publication est :{' '}
            <strong style={{ color: 'rgba(255,255,255,0.9)' }}>Azzedi Salemkour</strong>
          </p>
          <p style={{ marginTop: '0.4rem' }}>
            Contact :{' '}
            <a href="mailto:contact@safeheir.fr" style={{ color: '#00F2FE', textDecoration: 'none' }}>
              contact@safeheir.fr
            </a>
          </p>
        </Section>

        <Section title="3. Hébergeur">
          <p>Le site SafeHeir est hébergé par :</p>
          <InfoBox>
            <Row label="Raison sociale" value="Vercel Inc." />
            <Row label="Adresse" value="340 Pine Street Suite 900, San Francisco, CA 94104, États-Unis d'Amérique" />
            <Row
              label="Site web"
              value={
                <a href="https://vercel.com" target="_blank" rel="noopener noreferrer" style={{ color: '#00F2FE', textDecoration: 'none' }}>
                  https://vercel.com
                </a>
              }
            />
          </InfoBox>
          <p style={{ marginTop: '0.8rem', fontSize: '0.9rem' }}>
            Vercel Inc. agit en qualité d'hébergeur au sens de l'article 6-I-2° de la loi n° 2004-575
            du 21 juin 2004 pour la Confiance dans l'Économie Numérique (LCEN).
          </p>
          <p style={{ marginTop: '0.8rem' }}>
            Les données du service (coffres chiffrés, documents déposés) sont hébergées par Supabase Pte. Ltd.,
            65 Chulia Street #38-02/03, OCBC Centre, Singapore 049513, sur des serveurs situés dans l'Union
            européenne (région Stockholm, Suède).
          </p>
        </Section>

        <Section title="4. Contact">
          <p>Pour toute question, demande ou réclamation relative au site SafeHeir :</p>
          <p style={{ marginTop: '0.4rem' }}>
            Email :{' '}
            <a href="mailto:contact@safeheir.fr" style={{ color: '#00F2FE', textDecoration: 'none' }}>
              contact@safeheir.fr
            </a>
          </p>
          <p style={{ marginTop: '0.4rem' }}>
            Pour l'exercice de vos droits RGPD, consultez notre{' '}
            <Link to="/legal/confidentialite" style={{ color: '#00F2FE', textDecoration: 'none' }}>
              Politique de confidentialité
            </Link>.
          </p>
        </Section>

        <Section title="5. Propriété intellectuelle">
          <p>
            L'ensemble des éléments constituant le site SafeHeir — incluant, sans s'y limiter, la marque
            SafeHeir, le code source, les interfaces graphiques, les textes, les logotypes et tout autre
            contenu — est protégé par les dispositions du Code de la propriété intellectuelle.
          </p>
          <br />
          <p>
            Toute reproduction, représentation, modification, publication, adaptation ou exploitation,
            totale ou partielle, de ces éléments, par quelque procédé que ce soit, sans l'autorisation
            écrite préalable de l'éditeur, est strictement interdite et constitue une contrefaçon
            sanctionnée par les articles L. 335-2 et suivants du Code de la propriété intellectuelle.
          </p>
        </Section>

        <Section title="6. Données personnelles">
          <p>
            Les informations relatives au traitement des données personnelles effectué dans le cadre du
            service SafeHeir sont disponibles dans notre{' '}
            <Link to="/legal/confidentialite" style={{ color: '#00F2FE', textDecoration: 'none' }}>
              Politique de confidentialité
            </Link>.
          </p>
          <p style={{ marginTop: '0.6rem' }}>
            Pour toute réclamation, vous pouvez également vous adresser à la{' '}
            <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" style={{ color: '#00F2FE', textDecoration: 'none' }}>
              Commission Nationale de l'Informatique et des Libertés (CNIL)
            </a>.
          </p>
        </Section>

        <Section title="7. Droit applicable">
          <p>
            Les présentes mentions légales sont régies par le droit français. En cas de litige, les
            tribunaux français seront seuls compétents.
          </p>
        </Section>

      </div>

      {/* Footer navigation */}
      <div style={{ marginTop: '2rem', textAlign: 'center', display: 'flex', gap: '2rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        {[
          { to: '/legal/cgu', label: 'CGU' },
          { to: '/legal/confidentialite', label: 'Politique de confidentialité' },
          { to: '/faq', label: 'FAQ' },
          { to: '/', label: 'Accueil' },
        ].map(({ to, label }) => (
          <Link key={to} to={to} style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.9rem' }}
            onMouseEnter={(e) => e.target.style.color = '#00F2FE'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
          >
            {label}
          </Link>
        ))}
      </div>

    </div>
  </div>
);

export default MentionsLegalesPage;
